import axios from 'axios';

/*
*  This file contains all axios calls related to delete campaign on CB
*/

export const deleteAutomation = async (funnelId) => {
    const { data } = await axios.delete(`/app/funnel/funnelId=${funnelId}/delete`);

    return data;
};
